import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export const OrderRemoveConfirmationDialog = ({
  open,
  handleClose,
  handleConfirm,
}: {
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
}) => {
  return (
    <Dialog open={open} onClose={handleClose} scroll="paper">
      <DialogTitle>Varování</DialogTitle>
      <DialogContent dividers={true}>
        <DialogContentText>
          Máte rozpracovanou objednávku, zadáním nové objednávky ztratíte obsah
          košíku. Skutečně chcete pokračovat?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} color="primary">
          vyprázdnit košík a založit novou objednávku
        </Button>
        <Button onClick={handleClose}>Storno</Button>
      </DialogActions>
    </Dialog>
  );
};
